import Player from '@vimeo/player';

class IframeVimeo extends HTMLElement {
  constructor() {
    self = super();
    // Always call super first in constructor
    // Return value from super() is a reference to this element

    this.classList.add('media')
    this.videoId = this.getAttribute('video-id')
    this.videoKey = this.getAttribute('video-key')
    this.defaultCover = this.getAttribute('default-cover')
    this.posterUrl = this.defaultCover
  
    fetch(`https://vimeo.com/api/v2/video/${this.videoId}.json`)
        .then(response => response.json())
        .then(data => {
          iframeContainer.querySelector(".iframe__img").src = data[0].thumbnail_large
        })
    
    this.posterMarkup = `<figure class="iframe__poster figure-gradient">
      <img
        src="${this.posterUrl}"
        width="1280"
        height="720"
        alt="Poster"
        class="iframe__img"
        loading="lazy">
      <button
        class="button iframe__play"
        type="button"
        value="Play Youtube Video"
      >
        <i class="icon icon-play">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox="0 0 25 27" xml:space="preserve">
          <path fill="currentColor" d="M24,12.3L2.4,0.2C1.9-0.1,1.4-0.1,1,0.2C0.6,0.4,0.4,0.9,0.4,1.4v24.3c0,0.5,0.3,0.9,0.7,1.2
            C1.2,26.9,1.5,27,1.7,27c0.2,0,0.5-0.1,0.7-0.2L24,14.7c0.4-0.2,0.7-0.7,0.7-1.2S24.4,12.6,24,12.3z"/>
          </svg>
        </i>
        <span class="visually-hidden">Play Vimeo Video</span>
      </button>
    </figure>`;

    // Create a shadow root
    // const shadow = this.attachShadow({mode: 'open'});
    
    const iframeContainer = document.createElement('div');
    iframeContainer.setAttribute('class', 'iframe-container');

    // Create player element
    const wrapper = document.createElement('div');
    wrapper.setAttribute('id', `player-${this.videoKey}`);
    iframeContainer.appendChild(wrapper);

    iframeContainer.insertAdjacentHTML("beforeend", this.posterMarkup)

    this.appendChild(iframeContainer);
    
    
    this.player = new Player(`player-${this.videoKey}`, {
      id: this.videoId,
      width: 640
    });

    this.playButton = this.querySelector(".iframe__play")
    this.poster = this.querySelector(".iframe__poster")

    this.playButton.addEventListener("click", evt => {
      evt.preventDefault()
      this.poster.classList.add("iframe__poster--playing")
      this.player.play()
    })
    
    this.player.on("ended", () => {
      this.poster.classList.remove("iframe__poster--playing")
    });
  }
}

export default IframeVimeo
